<script setup>
import {ref, useTemplateRef, watch} from "vue";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import * as leaflet from "leaflet";
import HpoMapSearch from "@/components/hpo/HpoMapSearch.vue";

const model = defineModel({type: Boolean});
const props = defineProps({
    latitude: Number,
    longitude: Number,
});
const emit = defineEmits(['select']);

const mapElement = useTemplateRef('mapEl');
const initialized = ref(false);
const coordinates = ref(null);

watch(mapElement, (value) => {
    if (value && !initialized.value) {
        createMap();
    } else if (!value && initialized.value) {
        destroyMap();
    }
});

let map, marker;

function createMap() {
    map = leaflet.map(mapElement.value);
    if (props.latitude && props.longitude) {
        const coords = leaflet.latLng(props.latitude, props.longitude);
        map.setView(coords, 11);
        createMarker(coords);
    } else {
        map.setView([49.510, 13.409], 9);
    }

    leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    map.on('click', (event) => {
        selectPosition(event.latlng);
    });
}

function selectPosition(latlng) {
    coordinates.value = {
        latitude: latlng.lat,
        longitude: latlng.lng,
    };
    if (marker) {
        marker.setLatLng(latlng);
    } else {
        createMarker(latlng);
    }
}

function selectSearchResult({latlng}) {
    selectPosition(latlng);
    map.setView(latlng, 12);
}

function createMarker(latlng) {
    marker = leaflet.marker(latlng, {
        icon: leaflet.icon({
            iconUrl: markerIcon,
            iconRetinaUrl: markerIcon2x,
            shadowUrl: markerShadow,
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            tooltipAnchor: [16, -28],
            shadowSize: [41, 41],
        }),
        draggable: true,
        autoPan: true,
    });
    marker.addTo(map);
    marker.on('move', () => {
        const markerLatLng = marker.getLatLng();
        coordinates.value = {
            latitude: markerLatLng.lat,
            longitude: markerLatLng.lng,
        };
    });
}

function destroyMap() {
    map.remove();
}

function confirmSelection() {
    emit('select', coordinates.value);
    close();
}

function close() {
    model.value = false;
}
</script>

<template>
    <v-dialog v-model="model">
        <v-card>
            <div class="position-absolute" style="z-index: 10000; right: 16px; top: 16px; width: 420px;">
                <HpoMapSearch @select="selectSearchResult" />
            </div>
            <div ref="mapEl" style="height: 80vh"></div>
            <v-btn @click="confirmSelection" color="primary">
                {{ pgettext('action', 'Confirm') }}
            </v-btn>
        </v-card>
    </v-dialog>
</template>
